import { FC } from "react"
import { WithChildren } from "../../../_metronic/helpers"

type Props = {
    label: string
}

const HeaderItem:FC<Props & WithChildren> = ({label, children}) => {
    return(
    <div className="d-flex flex-row flex-center gap-2">
        <label className='fw-bold text-muted fs-7'>{label}</label>
        <div className="className='fw-bolder fs-7 text-dark">{children}</div>
    </div>
    )
}

export { HeaderItem }